export enum RoleSlugEnum {
  WORKER = 'worker',
  CLIENT = 'client',
  PARTNER = 'partner',
  CANDIDATE = 'candidate',
}
